import React, {useRef, useState} from 'react'
import useSyncSnapshotMenu from './useSyncSnapshotMenu'
import AceEditor from 'react-ace'

export function Editor (props) {
  const aceRef = useRef(null)
  const snapshot = useSyncSnapshotMenu(props.path)

  function handleSave () {
    snapshot.ref.set(aceRef.current.editor.getValue())
  }

  if (!snapshot) {
    return (<div>loading css editor...</div>)
  }

  return(<div className="menu-custom-css-wrapper no-print">
     <AceEditor
      value={snapshot.val() || ''}
      ref={aceRef}
      // name={product.id}
      mode="css"
      // theme="vibrant_ink"
      showGutter={true}
      tabSize={2}
      width='1000px'
      height='1000px'
      debounceChangePeriod={1000}
      commands= {[
        { name: 'save doc',
          bindKey: {win: 'Ctrl-S', mac: 'Command-S'},
          exec: (editor) => { handleSave() }
        }
      ]}
      editorProps={{
        height: '400px',
        width: '200px',


      }}
    />
  </div>)
 }

 export function Style (props) {
   const snapshot = useSyncSnapshotMenu(props.path)
  if (!snapshot) {
    return null
  }
   return (<style
     dangerouslySetInnerHTML={{__html: snapshot.val() }}
     ></style>)
 }
